import LegalPage from './LegalPage';
import privacyPolicy from '../data/privacyPolicy';

export default function PrivacyPolicy() {
  return <LegalPage document={privacyPolicy} />;
}